export const TEAM_TYPES = [
    {
        label: 'studio',
        value: 'studio'
    },
    {
        label: 'mediiia',
        value: 'mediiia'
    },    {
        label: 'brnd',
        value: 'brnd'
    },
    {
        label: 'hsecourses',
        value: 'hsecourses'
    },
    {
        label: 'hsestartup',
        value: 'hsestartup'
    },
    {
        label: 'galllleryart',
        value: 'galllleryart'
    },
    {
        label: 'hsespace',
        value: 'hsespace'
    },
    {
        label: 'channels',
        value: 'channels'
    },
    {
        label: 'autochannels',
        value: 'autochannels'
    },
]export const TEAM_TYPES = [
    {
        label: 'studio',
        value: 'studio'
    },
    {
        label: 'mediiia',
        value: 'mediiia'
    },    {
        label: 'brnd',
        value: 'brnd'
    },
    {
        label: 'hsecourses',
        value: 'hsecourses'
    },
    {
        label: 'hsestartup',
        value: 'hsestartup'
    },
    {
        label: 'galllleryart',
        value: 'galllleryart'
    },
    {
        label: 'hsespace',
        value: 'hsespace'
    },
    {
        label: 'channels',
        value: 'channels'
    },
    {
        label: 'autochannels',
        value: 'autochannels'
    },
]